module.exports = __webpack_public_path__ + "static/media/edit-white-ic.580320ce.svg";